<template>
  <div id="ebOrgDetailHeaderCard">
    <div class="three-card-box-main">
      <div class="three-card-box-red-line"></div>
      <div class="three-card-box-main-main">
        <slot/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrgDetailHeaderCard'
};
</script>
<style scoped lang="less">
  #ebOrgDetailHeaderCard {
    width: 100%;
    height: 117px;
    background: #fff;
    border-radius: 8px;
    position: relative;
    color: #000;

    &:hover {
      .three-card-box-red-line {
        height: 82px;
      }
    }
    .three-card-box-main {
      position: absolute;
      height: 100%;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
    }
    .three-card-box-red-line {
      height: 15px;
      width: 5px;
      background: #fb5b3b;
      margin: 19px 19px 0 14px;
      transition: height 0.5s;
    }
    .three-card-box-main-main {
      height: 100%;
      width: 96.2%;
    }
  }
</style>
